import PropTypes from "prop-types";
import { memo } from "react";
import { isObjectInList } from "@/Common/helpers/Array";

// Components
import TieredItem from "./TieredItem";

// MUI
import { Grid } from "@mui/material";

function ProductContent(props) {
	const {
		useMainProduct = true,
		blink = false,
		mainInput = {
			input: "Percent",
			value: 0,
			product: "",
		},
		mainSelectOptions = {
			text: "",
			useLabel: false,
			related: false,
		},
		mainGeneralAttributes = {
			error: false,
			related: false,
			addSeparator: false,
		},
		availableProducts = [],
		products = [],
		readOnly = false,
		areas = {
			area: "",
			main: "",
			products: "",
		},
		inputRelated = {
			area: "",
			column: "",
		},
		selectRelated = {
			area: "",
			column: "",
		},
		width = 6,
		productsError = false,
		productsErrors = {},
		index = 0,
		actionsCallbacks = {
			onClickInput: () => {},
			onFocusOut: () => {},
			onChangeType: () => {},
			onActionUpdate: () => {},
		},
		selectionCallbacks = {
			onSelect: () => {},
			onSelectOpen: () => {},
			onSelectClose: () => {},
		},
	} = props;

	return (
		<Grid container direction="row" spacing={4} rowSpacing={1}>
			{Boolean(useMainProduct) && (
				<TieredItem
					readOnly={readOnly}
					width={width}
					input={mainInput}
					selectOptions={{ ...mainSelectOptions, blink }}
					error={mainGeneralAttributes.error}
					related={mainGeneralAttributes.related}
					addSeparator={mainGeneralAttributes.addSeparator}
					actionsCallbacks={{
						onClickInput: () => {
							actionsCallbacks?.onClickInput?.(areas.area, areas.main);
						},
						onFocusOut: () => {
							actionsCallbacks.onFocusOut();
						},
						onChangeType: (_, input) => {
							actionsCallbacks?.onChangeType?.(areas.main, index, areas.main, input);
						},
						onActionUpdate: (value) => {
							actionsCallbacks?.onActionUpdate?.(areas.main, index, areas.main, value);
						},
					}}
				/>
			)}

			{products.map((item, idx) => {
				const itemKey = `tiered_item_product_${idx}`;
				const updatedList = [...availableProducts];
				if (item.product && !isObjectInList(updatedList, "label", item.product)) {
					updatedList.push({ label: item.product });
				}

				return (
					<TieredItem
						key={itemKey}
						addSeparator={true}
						readOnly={readOnly}
						width={width}
						input={item}
						products={updatedList}
						related={Boolean(inputRelated?.area === areas.products && inputRelated?.column === idx)}
						error={productsError || Boolean(productsErrors?.[item.product])}
						selectOptions={{
							text: item?.product || "",
							useLabel: Boolean(index),
							related: Boolean(selectRelated?.area === areas.products && selectRelated?.column === idx),
							blink,
						}}
						actionsCallbacks={{
							onClickInput: () => {
								actionsCallbacks?.onClickInput?.(areas.products, idx);
							},
							onFocusOut: () => {
								actionsCallbacks.onFocusOut();
							},
							onChangeType: (_, input) => {
								actionsCallbacks?.onChangeType?.(areas.products, index, idx, input);
							},
							onActionUpdate: (value) => {
								actionsCallbacks?.onActionUpdate?.(areas.products, index, idx, value);
							},
						}}
						selectionCallbacks={{
							onSelect: (value) => {
								selectionCallbacks?.onSelect?.(areas.products, idx, value);
							},
							onSelectOpen: () => {
								selectionCallbacks?.onSelectOpen?.(areas.products, idx);
							},
							onSelectClose: () => {
								selectionCallbacks?.onSelectClose?.(areas.products, idx);
							},
						}}
					/>
				);
			})}
		</Grid>
	);
}

const ProductItem = memo(ProductContent);
export { ProductItem };

ProductContent.propTypes = {
	useMainProduct: PropTypes.bool,
	blink: PropTypes.bool,
	mainInput: PropTypes.object,
	mainSelectOptions: PropTypes.object,
	mainGeneralAttributes: PropTypes.object,
	availableProducts: PropTypes.array,
	products: PropTypes.array,
	readOnly: PropTypes.bool,
	areas: PropTypes.object,
	inputRelated: PropTypes.object,
	selectRelated: PropTypes.object,
	width: PropTypes.number,
	productsError: PropTypes.bool,
	productsErrors: PropTypes.object,
	index: PropTypes.number,
	actionsCallbacks: PropTypes.object,
	selectionCallbacks: PropTypes.object,
};
